import { render, staticRenderFns } from "./message_detail.vue?vue&type=template&id=122e39c2&scoped=true"
import script from "./message_detail.vue?vue&type=script&lang=js"
export * from "./message_detail.vue?vue&type=script&lang=js"
import style0 from "./message_detail.vue?vue&type=style&index=0&id=122e39c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122e39c2",
  null
  
)

export default component.exports